import { render, staticRenderFns } from "./DevicesTableSortSkeleton.vue?vue&type=template&id=89d77f02&scoped=true"
import script from "./DevicesTableSortSkeleton.vue?vue&type=script&lang=js"
export * from "./DevicesTableSortSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DevicesTableSortSkeleton.vue?vue&type=style&index=0&id=89d77f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d77f02",
  null
  
)

export default component.exports